module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/dj-v2-2889df9ae4177d3d7305f5c18b77d3ba.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/dj-v2.svg
// module id = TmQI
// module chunks = 1 3 10 12 18